"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = function _default(Froala) {
  Froala.PLUGINS.customProfileFieldsPlugin = function (editor) {
    var getCustomProfileFields = function getCustomProfileFields() {
      return R.pipe(R.map(function (customField) {
        return ["{{match_info[".concat(customField.id, "]}}"), customField.name];
      }), R.fromPairs)(editor.opts.customProfileFields);
    };

    var setCustomProfileFields = function setCustomProfileFields(fields) {
      editor.opts.customProfileFields = fields;
    };

    var _init = function _init() {};

    return {
      _init: _init,
      setCustomProfileFields: setCustomProfileFields,
      getCustomProfileFields: getCustomProfileFields
    };
  };
};

exports.default = _default;